// Built-in lender short names for the LE Price Eng Lender dropdown.
// Source: LANIS Lender List V1.4 (Scotsman Guide 2025 top lenders, scrubbed).
export default Object.freeze([
  "A&D Mortgage",
  "Acra Lending",
  "Am Financial Network",
  "Am Heritage Lending",
  "Am Pacific Mort.",
  "AmeriHome",
  "AnnieMac",
  "Atlantic Bay",
  "Atlantic Coast",
  "Better Mortgage",
  "Canopy Mortgage",
  "Carrington Mortgage",
  "Change Lending",
  "Churchill Mort.",
  "CMG Home Loans",
  "Cornerstone",
  "Cornerstone First",
  "CrossCountry",
  "Fairway Independent",
  "FBC Mortgage",
  "First Community",
  "First Home Mortgage",
  "First Natl Bank Amer",
  "First United Bank",
  "GMFS Mortgage",
  "Guar. Rate Affinity",
  "Guild Mortgage",
  "Highlands Res.",
  "Homeowners Fin.",
  "Intercap Lending",
  "KBHS Home Loans",
  "Kind Lending",
  "Leader Bank",
  "LeaderOne Fin.",
  "loanDepot",
  "Luminate Bank",
  "Movement Mortgage",
  "Mutual of Omaha",
  "Nations Lending",
  "Neighborhood Loans",
  "New American Fund",
  "Newrez",
  "NexBank",
  "NFM Lending",
  "NJ Lenders",
  "Northpointe Bank",
  "NOVA Home Loans",
  "OCMBC",
  "OMG Home Loans",
  "OriginPoint",
  "Pennymac",
  "Planet Home Lend.",
  "Plaza Home Mort.",
  "PMRI",
  "PrimeLending",
  "PRMG",
  "Prosperity Home",
  "Rate",
  "Revolution Mortgage",
  "Ruoff Mortgage",
  "Service First",
  "Supreme Lending",
  "SWBC",
  "theLender",
  "TowneBank Mortgage",
  "USA Mortgage",
  "UWM",
  "V.I.P. Mortgage",
  "Waterstone Mort.",
  "Wintrust Mortgage",
]);
